import * as angular from "angular";
import {IController, ILogService} from "angular";

import {LogisticsVehicle} from "../../models/logistics-vehicle.model";
import {LogisticsVehicleStatusType} from "../../types/logistics-vehicle-status.type";
import {LogisticsVehiclesDialogsService} from "../../services/logistics-vehicles-dialogs-service.service";
import {
  VehicleStatusChangeReasonSettingsEntity
} from "../../../site-preferences/models/vehicle-status-change-reason-settings.model";
import {LogisticsVehicleService} from "../../services/logistics-vehicle-service.service";

export class LogisticsVehiclesTableRowCtrl implements IController {

  logisticsVehicle: LogisticsVehicle;
  onViewLogisticsVehicleClicked: Function;
  onLogisticsVehicleDeleted: Function;
  onUnbindVehicle: Function;

  public programTypesText: string;
  public isChangingStatus: boolean;

  /* @ngInject */
  constructor(private logisticsVehiclesDialogsService: LogisticsVehiclesDialogsService, private $log: ILogService, private logisticsVehicleService: LogisticsVehicleService) {
  }

  $onInit() {
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.logisticsVehicle && !changes.logisticsVehicle.isFirstChange()) {
      this.$onInit();
    }
  }

  onChangeStatus(logisticsVehicle: LogisticsVehicle, vehicleStatus: LogisticsVehicleStatusType) {
    const logisticsVehicleCopy = angular.copy(logisticsVehicle);
    if (logisticsVehicle.vehicleStatus === LogisticsVehicleStatusType.NotAvailable && vehicleStatus !== LogisticsVehicleStatusType.NotAvailable) {
      delete logisticsVehicleCopy.vehicleStatusChangeReason;
      logisticsVehicleCopy.vehicleStatus = vehicleStatus;
      this._updateLogisticsVehicle(logisticsVehicleCopy);
    } else if (vehicleStatus === LogisticsVehicleStatusType.NotAvailable) {
      this.logisticsVehiclesDialogsService.selectVehicleStatusChangeReason(logisticsVehicleCopy, logisticsVehicleCopy.vehicleStatus)
        .then((selectedVehicleStatusReason: VehicleStatusChangeReasonSettingsEntity) => {
          logisticsVehicleCopy.vehicleStatus = LogisticsVehicleStatusType.NotAvailable;
          logisticsVehicleCopy.vehicleStatusChangeReason = selectedVehicleStatusReason;
          this._updateLogisticsVehicle(logisticsVehicleCopy);
        })
        .catch((error) => {
          this.$log.debug('Dialog Closed');
        })
    }
  }

  private _updateLogisticsVehicle(logisticsVehicle: LogisticsVehicle) {
    this.isChangingStatus = true;
    this.logisticsVehicleService.updateLogisticsVehicle(logisticsVehicle)
      .then((updatedLogisticsVehicle) => {
        this.logisticsVehicle = {...updatedLogisticsVehicle, id: this.logisticsVehicle.id};
      })
      .finally(() => {
        this.isChangingStatus = false;
      })
  }
}

angular
  .module('bringoz.admin.logistics-vehicle')
  .component('logisticsVehiclesTableRow', {
    bindings: {
      logisticsVehicle: '<',
      onViewLogisticsVehicleClicked: '&',
      onLogisticsVehicleDeleted: '&',
      onUnbindVehicle: '&'
    },
    template: require('./logistics-vehicles-table-row.html').default,
    controller: LogisticsVehiclesTableRowCtrl
  });

